export const PhoneLength = 10;
export const maxLength = 255;
